import $axios from './axios';
import { sApi } from '@/utils/request';
/*************登录页面接口*****************/
// 账号验证
const _checkMobile = (params) => {
  return $axios.get('/checkmobile', {params: params})
}
// 验证密码
const _checkloginpwd = (data) => {
  return $axios.post('/checkloginpwd', data);
}
// 登录
const _login = (data) => {
  return $axios.post('/login', data);
}
const _submitLegalConfirmation = data => {
  return $axios.post('/legal-confirmation/submit-login-rule-confirmation', data);
}
const _prepareActivationLegalConfirmation = data => {
  return $axios.post('/legal-confirmation/prepare-activation-rule-confirmation', data);
}
// 退出登录
const _loginout = (data) => {
  return $axios.get('/logout', data);
}
// 获取验证码
const _sendsms = (data) => {
  return $axios.post('/sendsms', data);
}
// 验证码登录
const _smslogin = (data) => {
  return $axios.post('/smslogin', data);
}
// 忘记密码获取验证码
const _sendSmsCode = (data) => {
  return $axios.post('/send-password-reset-sms-code', data);
}
const _validateAccount = data => {
  return $axios.post('/check-password-reset-sms-code', data);
}
const _confirmPassword = data => {
  return $axios.post('/reset-password', data);
}
/** 获取供应商信息 */
const _getinfobyprovidermerchantid = (params) => {
  return $axios.get('/getinfobyprovidermerchantid', {params: params})
}

const _checksmscode = (data) => {
  return $axios.post('/checksmscode', data);
}
/*****************首页 *****************/
// 首页数据
const _getHomeData = () => {
  return $axios.get('/home');
}
// 首页通知栏
const _getInfoData = (params) => {
  return $axios.get('/supplierNotice/list', {params});
}
// 首页公告详情
const _getInfoDetail = (params) => {
  return $axios.get('/supplier-notice/info', {params});
}
// 取消请假
const _notSubmitVacation = () => {
  return $axios.post('/not-submit-vacation-time-form');
}
//申请休假
const _submitVacation = data => {
  return $axios.post('/submit-vacation-time-form', data);
}
// 消息列表
const _getMessage = (data) => {
  return $axios.post('/getmessage', data);
}
// 清除消息
const _clearMessage = (data) => {
  return $axios.post('/clearmessage', data);
}
// 最新寄送
const _lastSendOrder = () => {
  return $axios.get('/lastsendorder');
}
// 最新回收
const _lastRecoveryOrder = () => {
  return $axios.get('/lastrecoveryorder');
}
// 订单备注
const _addRemark = (data) => {
  return $axios.post('/addremark', data);
}

// 供应商公告已读
const _readSupplierNoticeFormData = (formData) => {
  return $axios.post('/supplier-notice/read', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}
// 获取首页代办相关统计接口
const _getTodoSummary = () => {
  return $axios.get('/home-page/get-todo-summary');
}

// 获取供应商待办
const _getSupplierUnprocessedTodo = () => {
  return sApi.getData('/get-unprocessed-todo-list');
}

// 待办完成
const _completeTodo = (params) => {
  return sApi.postData('/complete-todo', params);
}

// 获取对接人信息
const _getPickupInfo = () => {
  return $axios.get('/get-pickup-info');
};

/*****************订单页 *****************/
//获取订单标签
const _getOrderTags = data => {
  return $axios.post('/get-order-tags', data);
};
// 所有订单
const _getAllOrders = (data) => {
  return $axios.post('/allorders', data);
}
// 待实验
const _getWaittestOrders = (data) => {
  return $axios.post('/waittestorders', data);
}
// 待结算
const _getWaitSettleOrders = (data) => {
  return $axios.post('/waitsettleorders', data);
}
// 获取订单成本列表
const _getOrderCosts = data => {
  return $axios.post('/get-order-costs', data);
};
// 获取订单/变动金成本列表
const _getOrderSettleCosts = data => {
  return $axios.post('/get-order-settle-costs', data);
};
// 结算中
const _getSettlingOrders = (data) => {
  return $axios.post('/settlingorders', data);
}
// 已结算
const _getSettledOrders = (data) => {
  return $axios.post('/settledorders', data);
}
// 待回收
const _getWaitRecoveryOrders = (data) => {
  return $axios.post('/waitrecoveryorders', data);
}
// 差评
const _getBadOrders = (data) => {
  return $axios.post('/badorders', data);
}
// 获得当前是否是自营供应商
const _isproprietary = () => {
  return $axios.get('/isproprietary');
}
// 获得订单的处理记录
const _getTicketpmhandle = (params) => {
  return $axios.get('/ticketpmhandle', {params: params});
}
// 获得订单的差评明细
const _getBadcomment = (params) => {
  return $axios.get('/badcomment', {params: params});
}
// 获得订单的异议明细
const _getDissentinfo = (params) => {
  return $axios.get('/dissentinfo', {params: params});
}
// 超期
const _getTimeoutOrders = (data) => {
  return $axios.post('/timeoutorders', data);
}
const _sendOrderCycleReminder = (data) => {
  return $axios.post('/send-order-change-cycle-reminder', data);
}
const _getTimeoutcount = (data) => {
  return $axios.post('/timeoutorderscount', data);
}
// 订单回收
const _recovery = (data) => {
  return $axios.post('/recovery', data);
}
// 提交异议
const _applyiyi = (data) => {
  return $axios.post('/applyiyi', data);
}
// 撤回异议
const _chexyiyi = (data) => {
  return $axios.post('/chexyiyi', data);
}
// 订单详情
const _getOrderView = (params) => {
  return $axios.get('/orderview', {params: params});
}
// 导出待结算订单
const _exportWaitSettleOrders = (params) => {
  return $axios.get('/exportwaitsettleorders', {params: params});
}
// 已分派订单
const _getAllotOrders = (data) => {
  return $axios.post('/allotorders', data);
}
// 待上传结果
const _getWaitUploadOrders = (data) => {
  return $axios.post('/waituploadorders', data);
}
// 写汇报
const _saveProcess = data => {
  return $axios.post('/save-process', data);
}
// 获取历史汇报记录
const _getProcessList = (params) => {
  return $axios.get('/get-process-list', {params: params});
}
// 所有已完成
const _getCompleteOrders = (data) => {
  return $axios.post('/completeorders', data);
}
// 暂不可结算
const _getCannotSettleOrders = (data) => {
  return $axios.post('/cannotsettleorders', data);
}
// 导出所有已完成订单
const _exportCompleteOrders = (data) => {
  return $axios.post('/completeordersexport', data);
}
// 导出暂不可结算订单
const _exportCannotsettleOrders = (data) => {
  return $axios.post('/cannotsettleordersexport', data);
}
// 导出所有已完成订单
const _exportSettlingOrders = (data) => {
  return $axios.post('/settlingordersexport', data);
}
// 导出所有已完成订单
const _exportSettledOrders = (data) => {
  return $axios.post('/settledordersexport', data);
}
// 获取待审核订单
const _getWaitverifyOrders = (data) => {
  return $axios.post('/waitverifyorders', data);
}
// 获取运输中订单
const _getTransportOrders = (data) => {
  return $axios.post('/pendingorders', data);
}
// 获取待扫码订单
const _getWaitScanOrders = (params) => {
  return $axios.get('/wait_scan_orders', { params });
}

/*****************个人页 *****************/
// 撤回异议
const _getAccountInfo = (params) => {
  return $axios.get('/accountinfo', { params });
}
// 设置个人信息
const _setpwd = (data) => {
  return $axios.post('/setpwd', data);
}
// 撤回异议
const _saveReceiptInfo = (data) => {
  return $axios.post('/savereceiptinfo', data);
}
// 密码校验
const _checkpwd = (data) => {
  return $axios.post('/checkpwd', data);
}
const _settleAccount = () => {
  return $axios.get('/settleaccount');
}
// 获取测试项目
const _getProducts = () => {
  return $axios.get('/getproducts');
}
// 获取分部列表
const _getAddressids = () => {
  return $axios.get('/get_branch_address_list');
}
// 获取复测原因列表（自营）
const _getResetReason = () => {
  return $axios.get('/getrepeatreason');
}
// 团队管理成员列表
const _memberlist = () => {
  return $axios.get('/memberlist');
}
// 获取在职员工列表
const _getcrmaccount = () => {
  return $axios.get('/getcrmaccount');
}
// 三方供应商添加账号验证
const _checkmember = (params) => {
  return $axios.get('/checkmember', {params: params});
}
// 添加成员
const _addmember = (data) => {
  return $axios.post('/addmember', data);
}
// 修改成员
const _updatemember = (data) => {
  return $axios.post('/updatemember', data);
}
// 删除成员
const _delmember = (params) => {
  return $axios.get('/delmember', {params: params});
}
// 更换手机号
const _updatemobile = (data) => {
  return $axios.post('/updatemobile', data);
}
// 更换密码
const _updatepwd = (data) => {
  return $axios.post('/updatepwd', data);
}
// 获取用户信息
const _getaccount = () => {
  return $axios.get('/getaccount');
}
// 验证码判断
const _checkcode = (data) => {
  return $axios.post('/checkcode', data);
}

/*****************当月结算 *****************/
const SETTLE_SUBMIT_TYPE_NORMAL = 1;
const SETTLE_SUBMIT_TYPE_PRE_SUBMIT = 2;
const SETTLE_DEAL_STATUS_PRE_SUBMIT = 5;

// 结算前检查
const _checkSettleStatus = (data) => {
  return $axios.post('/checksettlestatus', data);
}
// 结算前数据展示
const _preApplySettle = (data) => {
  return $axios.post('/preapplysettle', data);
}
// 获取预提交结算预览
const _getPreSubmitSettlePreview = (data) => {
  return $axios.get('/get-pre-submit-settle-preview', { params: data });
}
// 确认预提交结算
const _confirmPreSubmission = (data) => {
  return $axios.post('/confirm-pre-submission', data);
}
// 取消预提交结算
const _cancelOrderSettle = (data) => {
  return $axios.post('/cancel-order-settle', data);
}
// 提交结算
const _applySettle = (data) => {
  return $axios.post('/settle', data);
}
// 结算核对设置
const _setVerifyflag = (data) => {
  return $axios.post('/setverifyflag', data);
}
// 设置核对状态
const _sethdStatus = (data) => {
  return $axios.post('/sethdstatus', data);
}
// 结算详情
const _getSettleView = (params) => {
  return $axios.get('/settleview', {params: params});
}

// 获取供应商发票列表
const _getSupplierInvoiceList = (params) => {
  return $axios.get('/get-payment-invoices', { params });
}

/*****************报告相关 *****************/
// 获取上传报告
const _getReports = (params) => {
  return $axios.get('/getreports', {params: params});
}
// 删除上传报告
const _delReport = (params) => {
  return $axios.get('/delreport', {params: params});
}
// 上传报告校验订单号
const _checkUpload = (data) => {
  return $axios.post('/checkupload', data);
}
// 上传报告
const _uploadReport = (data) => {
  return $axios.post('/uploadreport', data);
}
const _uploadResult = data => {
  return $axios.post('/order-report/test-result-abnormal', data);
}
// 获取结果格式要求文件列表
const _getInstructionFileList = (params) => {
  return $axios.get('/test-result/get-instruction-file-list', {params});
}
// 多个文件上传报告
const _uploadreports = (data) => {
  return $axios.post('/uploadreports', data);
}

const _uploadError = data => {
  return $axios.post('/ossuploadlog', data)
}

/** 样品回收订单 */
const _recoverySampleOrder = data => {
  return $axios.post('/get_wait_recovery_orders_count', data);
}

const _recoverySampleOrderList = data => {
  return $axios.post('/get_wait_recovery_orders', data);
}

const _recovery_lock = data => {
  return $axios.post('/locked_recovery_orders', data);
}

const _pre_recovery_pending = data => {
  return $axios.post('/pre_recovery_pending', data);
}

const _create_recovery_order = data => {
  return $axios.post('/create_recovery_order_pending', data);
};

const _confirm_pack = data => {
  return $axios.post('/confirm_pack_recovery_pending', data);
}

const _manually_send_recovery = data => {
  return $axios.post('/manually_send_recovery_orders', data);
}

const _create_recovery_pending = data => {
  return $axios.post('/wait_pack_order_print', data);
}

const _cancel_send_sample = data => {
  return $axios.post('/cancel_recovery_pending', data);
}

const _batch_send_order = data => {
  return $axios.post('/batch_send_recovery_order', data);
}

const _pack_sample = data => {
  return $axios.post('/wait_pack_order_print', data);
}

// start --反馈项相关接口--
// 获得订单的预设反馈项
const _getOrderFeedbacks = (params) => {
  return $axios.get('/getfeedbacks', {params});
}
// 订单增加反馈内容
const _addOrderFeedback = (data) => {
  return $axios.post('/orderfeedback', data);
}
// 获得订单反馈内容
const _getOrderFeedback = (params) => {
  return $axios.get('/orderfeedback', {params});
}
// 删除订单反馈内容
const _delOrderFeedback = (params) => {
  return $axios.get('/orderfeedbackdel', {params});
}
// 将crm传递过来的消息设为已读
const _readcrmacs = (params) => {
  return $axios.get('/readcrmacs', {params});
}
// 获得crm传递过来的消息
const _getcrmacs = (params) => {
  return $axios.get('/getcrmacs', {params});
}
// end --反馈项相关接口--

// 供应商分层分级相关接口
// 获取项目星级详情
export const _projectStarGrade = (params) => {
  return $axios.get('/get-project-star-grade', {params});
};
// 获取信誉分操作记录
export const _reputationScoreRecordList = (params) => {
  return $axios.get('/get-reputation-score-record-list', {params});
};

// 供应商上下架相关接口
const _testProjectList = (params) => {
  return $axios.get('/getmerchantandproductdetail', {params});
};

const _undesample = params => {
  return $axios.post('/undesampling', params);
};

const _getAllTestProject = params => {
  return $axios.get('/getallproviderproduct', {params});
};

const _getUndeSampling = params => {
  return $axios.get('/gethistory', {params});
};

const _deletePause = params => {
  return $axios.post('/deletepause', params);
};

const _setFitFact = params => {
  return $axios.post('/set-fit-fact', params);
};

/** 绩效 */
const _getTableTestList = params => {
  return $axios.get('/getallproduct', {params});
}

const _getPerformanceList = params => {
  return $axios.get('/getlist', {params});
}

const _getTesterList = params => {
  return $axios.get('/getalltester', {params});
}

const _getCreaterList = params => {
  return $axios.get('/getallcreater', {params});
}

const _logexportedexcel = params => {
  return $axios.post('/logexportedexcel', params);
}

const _logexportedexcelall = params => {
  return $axios.post('/logexportedexcelall', params);
}

/** 寄样订单预排班 */
const _getworkingkegsorderqueue = params => {
  return $axios.get('/getworkingkegsorderqueue', {params});
}
const _getAllTestList = params => {
  return $axios.get('/getworkingkeg', {params});
}
const _getPatternList = params => {
  return $axios.get('/getmerchantbuffet', {params});
}
const _getOrderNumAndAssetsKegs = params => {
  return $axios.get('/get-order-num-and-assets-kegs', {params});
}
const _getPauseTestConditionList = params => {
  return $axios.get('/get-pause-test-situation', {params});
}
const _testArrange = params => {
  return $axios.post('/test-arrange', params);
};
// 获取三方待回收列表tab统
const _getwaitrecoveryorderscount = params => {
  return $axios.post('/getwaitrecoveryorderscount', params);
}
// 获取异议原因
const _getReasons = params => {
  return $axios.post('/getSettleDisputeCommitReasons', params)
}
//催办
const _urgeHandle = params => {
  return $axios.post('/sendSettleDisputeUrgeNotice', params);
};

const _getDissentGuide = params => {
  return $axios.get('/getDisputeGuide', params)
}

/** 科学指南针协议 */
const _getagreementlist = params => {
  return $axios.get('/getagreementlist', params)
}

const _getCountryCode = (params) => {
  return $axios.get('/getcountrycode', params);
};

const _getagreementdetail = params => {
  return $axios.get('/getagreementdetail', {params})
}

/** 仪器管理 */
const _getschedulelist = params => {
  return $axios.get('/getscheduledetail', {params})
}

const _getallpattern = params => {
  return $axios.get('/get-pattern-list', {params})
}

const _getschedulelog = params => {
  return $axios.get('/getschedulelog', {params})
}

const _getscheduletemplate = params => {
  return $axios.get('/getscheduletemplate', {params})
}

const _uploadscheduleexcel = params => {
  return $axios.post('/uploadscheduleexcel', params)
}

const _gettesterSegment = params => {
  return $axios.get('/gettesterSegment', {params})
}

const _getmerchantbuffets = params => {
  return $axios.get('/getmerchantbuffets', {params})
}

const _getproductsegment = params => {
  return $axios.get('/getproductsegment', {params})
}

const _getMerchantStatus = params => {
  return $axios.get('/get-merchant-safeguard-status', {params})
}

const _getMerchantBuffet = params => {
  return $axios.get('/get-merchant-buffet', {params})
}

const _getSafeguardItem = params => {
  return $axios.get('get-safeguard-item', {params})
}

const _saveSafeguardLog = params => {
  return $axios.post('/save-safeguard-log', params)
}

const _saveBatchSafeguardLog = params => {
  return $axios.post('/batch-save-safeguard-log', params)
}

const _getSafeguardLog = params => {
  return $axios.get('/get-safeguard-log', {params})
}

const _getSafeguardRecord = params => {
  return $axios.get('/get-safeguard-log-list', {params})
}

const _getAllSafeguardItem = (params) => {
  return $axios.get('get-all-safeguard-item', { params })
}

const _confirmSafeguardInfo = params => {
  return $axios.post('/confirm-safeguard-log', params)
}

const _delSafeguardLog = params => {
  return $axios.post('/del-safeguard-log', params)
}

const _getSafeguardDeatil = params => {
  return $axios.get('/get-safeguard-detail', {params})
}
const _getAssetSubInfo = params => {
  return $axios.get('/get-asset-sub-info', {params});
}
const _getgroupmember = () => {
  return $axios.get('/getgroupmember');
}
// 置为分批测订单
const _setSplitTestRequest = params => {
  return $axios.post('/split-test/open', params);
}
// 完成分批测订单
const _finishSplitTestRequest = params => {
  return $axios.post('/split-test/finish', params);
}
// 判断能否置为分批测
const _getOrderValidation = params => {
  return $axios.get('/split-test/get-order-validation', { params });
}
const _checkSplitTestFinished = params => {
  return $axios.get('/split-test/is-finished', { params });
}
const _getVisitorData = params => {
  return $axios.get('/get-visit-log', { params });
}
const _getQRCode = params => {
  return $axios.get('/get-qrcode', {params});
}
const _getExportData = params => {
  return $axios.post('/export-log', params);
}
const _getExtraTable = params => {
  return $axios.get('/order-questionnaire/get-extra-table', {params});
}
const _saveExtraTable = params => {
  return $axios.post('/order-questionnaire/save-extra-table', params);
}
const _getSupplierPrice = params => {
  return $axios.get('/order-questionnaire/checkCost', {params});
}
const _getOrderReport = params => {
  return $axios.get('/getreports', {params})
}
// 仪器列表-未安装
const _getUnuseLabAssetsList = params => {
  return $axios.get('/unuse-lab-assets-list', {params});
}
// 仪器列表-确认到货
const _confirmArrival = params => {
  return $axios.post('/confirm-arrival', params);
}
// 仪器列表-确认已安装
const _confirmInstall = params => {
  return $axios.post('/confirm-install', params);
}
// 档案详情
const _getAssetInfo = params => {
  return $axios.get('/get-asset-info', {params});
}
// 档案提交审核
const _addAuditInfo= params => {
  return $axios.post('/add-audit-info', params);
}
// 获取最近一次提交审核记录
const _getRecentlyAuditLog = params =>{
  return $axios.get('/get-recently-audit-log', {params});
};
// 批量查询仪器是否关联测试项目
const _batchGetMerchantBuffetStatus = params =>{
  return $axios.get('/batch-get-merchant-buffet-status', {params});
};
// 顺丰打印
const _getAccessToken = params => {
  return $axios.get('/order-express/sf-token', { params });
}
const _getPrintHtml = params => {
  return $axios.post('https://bspgw.sf-express.com/std/service', params, { headers: {'Content-Type': 'application/x-www-form-urlencoded'} });
}
const _sfDownload = params => {
  return $axios.post('/order-express/sf-download', params);
}
const _getRzcVerifyState = params => {
  return $axios.post('/order-report/get-rzc-verify-state', params);
}
const _getRzcFailedReportOrders = () => {
  return $axios.get('/order-report/get-rzc-failed-report-orders');
}
const _isRzcSupported = () => {
  return $axios.get('/order-report/is-rzc-supported');
}
/** 根据模板类型获取汇报模板 */
const _getProcessTemplate = (params) => {
  return $axios.get('/get-process-template-by-type', { params });
}
/** 供应商系统 - 根据订单id获取当前汇报周期 */
const _getCurrentReportCycle = (params) => {
  return $axios.get('/get-current-report-cycle', { params });
}

// 获取供应商可编辑订单问卷内容
const _getEditableContent = (params) => {
  return $axios.get('/order-test-content/get-editable-content', { params });
}

// 校验实验内容变更
const _checkTestContent= (params) => {
  return $axios.post('/order-test-content/check-content', params);
}

// 获取供应商可编辑订单问卷内容
const _saveTestContent = (params) => {
  return $axios.post('/order-test-content/save', params);
}

// 获取首页项目星级列表
const _getHomeProjectGradeList = (params) => {
  return $axios.get('/get-home-project-grade-list', { params });
}

// 获取未配置能力测试项目数
const _getUnconfiguredAbilityProducts = params => {
  return $axios.get('/get-unconfigured-ability-products', { params });
}

// 保存已测样品数
const _saveFinishedSamples = params => {
  return $axios.post('/split-test/save-finished-samples', params);
}

// 获取待取件订单数
const _getWaitPickupOrders = params => {
  return $axios.get('check-wait-upload-order-pickup', { params });
}

const _getProviderMerchant = () => {
  return $axios.get('/get-provider-merchant');
}
const _getFaultyComponent = (params) => {
  return $axios.get('/get-pattern-parts', { params });
}
const _getMonthView = params => {
  return sApi.getData('/product-segment/get-month-view', params);
};
const _batchSettingMachineTime = (params) => {
  return sApi.postData('/product-segment/set-batch', params);
}
const _getProviderProductByMerchant = (params) => {
  return sApi.getData('/get-provider-product-by-merchant', params);
}
const _getImageDetail = (params) => {
  return sApi.getData('/supplier-product-image/get-detail', params);
}
// 测试项目页面，上传仪器图片后，发起审核
const _reviewImage = (params) => {
  return sApi.postData('/supplier-product-image/submit-review', params);
}
// 结算前 能力维护和仪器图片检查
const _checkAbility = params => {
  return sApi.getData('/get-unconfigured-ability-products', params);
};
const _checkImage = params => {
  return sApi.getData('/get-unconfigured-image-products', params);
}

const _getRepeatProject = params => {
  return sApi.getData('/getrepeatproject', params);
}

const _confirmOrderArrived = params => {
  return sApi.postData('/confirm-order-arrived', params);
}

const _getSamplingSaveWays = params => {
  return sApi.getData('/get-sampling-save_ways', params);
}

const _getOrderInfoForInspection = params => {
  return sApi.getData('/get-order-info-for-inspection', params);
}

const _confirmReceivedSample = params => {
  return sApi.postData('/confirm-received-sample', params);
}

const _recordSampleCollection = params => {
  return sApi.postData('/record-sample-collection', params);
}

const _saveSampleStorageMode = params => {
  return sApi.postData('/save-sample-storage-mode', params);
}

export {
  _getwaitrecoveryorderscount,
  _checkMobile,
  _checkloginpwd,
  _login,
  _submitLegalConfirmation,
  _prepareActivationLegalConfirmation,
  _loginout,
  _sendsms,
  _smslogin,
  _sendSmsCode,
  _validateAccount,
  _confirmPassword,
  _getinfobyprovidermerchantid,
  _checksmscode,
  _getHomeData,
  _getInfoData,
  _notSubmitVacation,
  _submitVacation,
  _getMessage,
  _clearMessage,
  _lastSendOrder,
  _lastRecoveryOrder,
  _getOrderTags,
  _getAllOrders,
  _getWaittestOrders,
  _getWaitSettleOrders,
  _getOrderCosts,
  _getOrderSettleCosts,
  _getSettlingOrders,
  _getSettledOrders,
  _getWaitRecoveryOrders,
  _getBadOrders,
  _getTimeoutOrders,
  _getTimeoutcount,
  _recovery,
  _applyiyi,
  _chexyiyi,
  _getAccountInfo,
  _setpwd,
  _saveReceiptInfo,
  _checkpwd,
  _settleAccount,
  _checkSettleStatus,
  _preApplySettle,
  _getPreSubmitSettlePreview,
  _confirmPreSubmission,
  _cancelOrderSettle,
  _applySettle,
  SETTLE_SUBMIT_TYPE_NORMAL,
  SETTLE_SUBMIT_TYPE_PRE_SUBMIT,
  SETTLE_DEAL_STATUS_PRE_SUBMIT,
  _setVerifyflag,
  _sethdStatus,
  _getOrderView,
  _getSettleView,
  _getSupplierInvoiceList,
  _exportWaitSettleOrders,
  _addRemark,
  _getAllotOrders,
  _getProducts,
  _getAddressids,
  _getResetReason,
  _memberlist,
  _getcrmaccount,
  _checkmember,
  _addmember,
  _updatemember,
  _delmember,
  _updatemobile,
  _updatepwd,
  _getaccount,
  _checkcode,
  _getWaitUploadOrders,
  _saveProcess,
  _getProcessList,
  _getReports,
  _getCompleteOrders,
  _getCannotSettleOrders,
  _exportSettledOrders,
  _exportSettlingOrders,
  _exportCannotsettleOrders,
  _exportCompleteOrders,
  _getWaitverifyOrders,
  _getTransportOrders,
  _getWaitScanOrders,
  _delReport,
  _checkUpload,
  _uploadReport,
  _uploadResult,
  _uploadreports,
  _uploadError,
  _recoverySampleOrder,
  _recoverySampleOrderList,
  _recovery_lock,
  _pre_recovery_pending,
  _create_recovery_order,
  _confirm_pack,
  _manually_send_recovery,
  _create_recovery_pending,
  _cancel_send_sample,
  _batch_send_order,
  _pack_sample,
  _getOrderFeedbacks,
  _addOrderFeedback,
  _getOrderFeedback,
  _delOrderFeedback,
  _readcrmacs,
  _getcrmacs,
  _isproprietary,
  _getTicketpmhandle,
  _getBadcomment,
  _getDissentinfo,
  _testProjectList,
  _undesample,
  _getUndeSampling,
  _getAllTestProject,
  _deletePause,
  _setFitFact,
  _getTableTestList,
  _getPerformanceList,
  _getTesterList,
  _getCreaterList,
  _logexportedexcel,
  _logexportedexcelall,
  _getworkingkegsorderqueue,
  _getAllTestList,
  _getPatternList,
  _getOrderNumAndAssetsKegs,
  _getPauseTestConditionList,
  _testArrange,
  _getReasons,
  _urgeHandle,
  _getDissentGuide,
  _getagreementlist,
  _getCountryCode,
  _getagreementdetail,
  _getschedulelist,
  _getallpattern,
  _getschedulelog,
  _getscheduletemplate,
  _uploadscheduleexcel,
  _gettesterSegment,
  _getmerchantbuffets,
  _getproductsegment,
  _getMerchantStatus,
  _getMerchantBuffet,
  _getSafeguardItem,
  _saveSafeguardLog,
  _saveBatchSafeguardLog,
  _getSafeguardLog,
  _getSafeguardRecord,
  _getAllSafeguardItem,
  _confirmSafeguardInfo,
  _delSafeguardLog,
  _getSafeguardDeatil,
  _getAssetSubInfo,
  _getgroupmember,
  _setSplitTestRequest,
  _finishSplitTestRequest,
  _getOrderValidation,
  _getVisitorData,
  _getQRCode,
  _getExportData,
  _getExtraTable,
  _saveExtraTable,
  _getSupplierPrice,
  _getOrderReport,
  _getUnuseLabAssetsList,
  _confirmArrival,
  _getAssetInfo,
  _confirmInstall,
  _addAuditInfo,
  _getRecentlyAuditLog,
  _batchGetMerchantBuffetStatus,
  _checkSplitTestFinished,
  _getAccessToken,
  _getPrintHtml,
  _sfDownload,
  _getRzcVerifyState,
  _getRzcFailedReportOrders,
  _isRzcSupported,
  _getProcessTemplate,
  _getCurrentReportCycle,
  _getEditableContent,
  _checkTestContent,
  _saveTestContent,
  _getHomeProjectGradeList,
  _getUnconfiguredAbilityProducts,
  _saveFinishedSamples,
  _getWaitPickupOrders,
  _getProviderMerchant,
  _getInfoDetail,
  _getFaultyComponent,
  _sendOrderCycleReminder,
  _readSupplierNoticeFormData,
  _getTodoSummary,
  _getPickupInfo,
  _getMonthView,
  _batchSettingMachineTime,
  _getProviderProductByMerchant,
  _getImageDetail,
  _reviewImage,
  _checkAbility,
  _checkImage,
  _getInstructionFileList,
  _getOrderInfoForInspection,
  _confirmReceivedSample,
  _confirmOrderArrived,
  _recordSampleCollection,
  _getRepeatProject,
  _getSamplingSaveWays,
  _saveSampleStorageMode,
  _getSupplierUnprocessedTodo,
  _completeTodo,
}
